import React from "react";
import { Box, Typography } from "@mui/material";
import ConstructionIcon from "@mui/icons-material/Construction";

const UnderConstruction: React.FC = () => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100%",
        gap: 2,
      }}
    >
      <ConstructionIcon sx={{ fontSize: 64, color: "text.secondary" }} />
      <Typography variant="h5" color="text.secondary">
        Under Construction
      </Typography>
    </Box>
  );
};

export default UnderConstruction;
